import 'core-js';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import { enableES5 } from 'immer';

import React from 'react';
import ReactDOM from 'react-dom';
import { createHashHistory, createMemoryHistory } from 'history';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { onLocationChange } from 'actions/app';
import configureStore from './store/configureStore';
import AppContainer from './containers/App';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Platform from './platform';
import customGA from './helpers/customGA';
import moment from 'moment-timezone';
import 'moment/locale/uk';
import 'moment/locale/en-gb';

Platform.initialize();

customGA.initialize();

// Immer uses Proxy object by default.
// On some devices this object could be unavailable because of ES5 environment
// https://immerjs.github.io/immer/docs/installation
enableES5();

// BrowserHistory and hashHistory don’t work smoothly on tizen
const history = Platform.getName() === 'Tizen' ? createMemoryHistory() : createHashHistory();

//For Volia inner analytics task. Yes it is a huge crutch, but we are working for Volia )
export const store = configureStore(history);

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

let prevLocation = history.location;

history.listen((location, action) => {
  // Trigger location change for counting authSteps
  store.dispatch(onLocationChange({ location, prevLocation, action }));
  customGA.trackPageView(location.pathname);
  prevLocation = location;
});

moment.tz.setDefault('Europe/Kiev');

moment.updateLocale('en-gb', {
  monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
});

moment.updateLocale('uk', {
  monthsShort: 'січ_лют_бер_кві_тра_чер_лип_сер_вер_жов_лис_гру'.split('_'),
});

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <AppContainer history={history} />
      </QueryClientProvider>
    </I18nextProvider>
  </Provider>,
  document.getElementById('root'),
);
